const E = {
  title: 'Customer Portal Login',
  sub: 'Secure access to your results and more',
  form: {
    code: {
      label: 'Verification code',
      error: 'Verification code is a required field',
    },
    buttons: {
      submit: 'submit',
      cancel: 'cancel',
    },
  },
  links: {
    resend: 'Resend verification code',
  },
};

const F = {
  title: 'Connexion au Portail Client',
  sub: 'Accès sécurisé à vos résultats et plus encore',
  form: {
    code: {
      label: 'Code de vérification',
      error: 'Le code de vérification est un champ obligatoire',
    },
    buttons: {
      submit: 'Soumettre',
      cancel: 'Annuler',
    },
  },
  links: {
    resend: 'Renvoyer le code de vérification',
  },
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/verification.js